import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
} from './base-authenticated.service';

export interface userInterface {
  id: number;
  username: string;
  organizations: { id: number; name: string }[];
  email: string;
  first_name: string;
  last_name: string;
  display_name: string;
  identity_email: string;
  identity_picture_url: string;
  consent_accepted_at?: string | null;
  consent_version?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient
  ) {
    super(auth, httpClient);
  }

  // public getProjectList<T = projectInterface>(
  //   params: httpQueryParams = {}
  // ): Observable<PaginatedResponse<T>> {
  //   return this.getList<T>('api/projects/', params);
  // }

  public getUserDetail<T = userInterface>(
    // projectId: number,
    params: httpQueryParams = {}
  ): Observable<T> {
    let path = `api/users/me/`;
    return this.getDetail<T>(path, params);
  }

  public acceptConsent<T = userInterface>(version: string): Observable<T> {
    let path = `api/users/accept_consent/`;
    return this.post<T>(path, {}, { version });
  }

  public rejectConsent<T = userInterface>(version: string): Observable<T> {
    let path = `api/users/reject_consent/`;
    return this.post<T>(path, {}, { version });
  }
}
